export const language: any ={
    LabelLogin: "လော့ဂ်အင်",
    LabelForgotPw: "စကားဝှက်မေ့သွားပါသလား",
    LabelSignUp: "အကောင့်ဖွင့်ရန်",
    LabelRememberMe: "မှတ်သားရန်",
    Or: "သို့မဟုတ်",
    Email: "အီးမေးလ်",
    Password: "စကားဝှက်",
    LangKo: "ကိုးရီးယား",
    LangEn: "အင်္ဂလိပ်",
    LangVi: "ဗီယက်နမ်",
    LabelCondition: "စည်းကမ်းချက်များသဘောတူပါသည်",
    FullAgreement: "အားလုံးသဘောတူပါသည်",
    Next: "နောက်တစ်ဆင့်",
    PrivacyPolicy: `ကိုယ်ရေးကိုယ်တာအချက်အလက် မူဝါဒ <span class="text-[#ff6741]">(လိုအပ်သည်)</span>`,
    TermOfUse: `အသုံးပြုခြင်း စည်းမျဉ်းများ <label class="text-[#ff6741]">(လိုအပ်သည်)</label>`,
    VerifyPassword: "စကားဝှက်အတည်ပြုပါ",
    PlaceHolderPassword: "အင်္ဂလိပ်စာလုံး၊ အနံ့နံ့၊ သင်္ကေတ ၈ လုံးအထက်ထည့်ပါ",
    DuplicateCheck: "အတူတူကြည့်ပါ",
    LabelIdEmail: "ID (အီးမေးလ်)",
    GN_02_MSG_01: "သင့်အက်ပ်ဗားရှင်းဟောင်းနေပါပြီ။ ဆက်လက်အသုံးပြုရန် အပ်ဒိတ်လုပ်ပါ။",
    AU_02_MSG_01: "မှန်ကန်သော အီးမေးလ်ပုံစံထည့်ပါ။",
    AU_01_MSG_01: "ID သို့မဟုတ် စကားဝှက်မှားနေသည်။ ထပ်မံကြိုးစားပါ။",
    AU_02_MSG_02: "ဤအီးမေးလ်သည် စနစ်တွင်ရှိပြီးဖြစ်သည်။ အခြားအီးမေးလ်အသုံးပြုပါ။",
    AU_02_MSG_03: "ဤအီးမေးလ်ကို အသုံးပြုနိုင်ပါသည်။",
    AU_02_MSG_04: "အီးမေးလ်ရရှိနိုင်မှု စစ်ဆေးပါ။",
    AU_02_MSG_05: "အင်္ဂလိပ်စာလုံး၊ အနံ့နံ့၊ သင်္ကေတ ၈ လုံးအထက်ထည့်ပါ။",
    AU_02_MSG_06: "စကားဝှက်များ မတူညီပါ။",
    AU_03_MSG_01: "အီးမေးလ်ကို မှန်ကန်စွာ ထည့်ပါ။",
    AU_03_MSG_02: "ဤအီးမေးလ်သည် စနစ်တွင် မရှိပါ။",
    AU_03_MSG_04: "※ အတည်ပြုကုဒ်ကို မှတ်ပုံတင်ထားသော အီးမေးလ်ထံ ပေးပို့ပြီးပါပြီ။",
    LabelRegisterComplete: "အကောင့်ဖွင့်ခြင်း ပြီးစီးပါပြီ!",
    LabelLoginToUseService: "ဝန်ဆောင်မှုကို အသုံးပြုရန် ဝင်ရောက်ပါ။",
    LabelDontRememberPassword: "စကားဝှက်ကို မမှတ်မိတော့ဘူးလား?",
    LabelYouCanFindEmail: "အတည်ပြုအီးမေးလ်ဖြင့် ရှာဖွေနိုင်သည်။",
    LabelPasswordTemporarySendToEmail: "※ စာရင်းသွင်းထားသော အီးမေးလ်ထံ သုံးစွဲသူရပ်တည်စကားဝှက်ပေးပို့မည်။",
    SendVerifyNumber: "အတည်ပြုနံပါတ် ပို့ပါ",
    LabelCheckYourEmailForTemporaryPassword: "အီးမေးလ်မှ သုံးစွဲသူရပ်တည်စကားဝှက်ကို စစ်ဆေးပါ။",
    PlaceHolderTemporaryPassword: "သုံးစွဲသူရပ်တည်စကားဝှက်ထည့်ပါ",
    LabelTemporaryPassword: "သုံးစွဲသူရပ်တည်စကားဝှက်",
    LabelDidntReceiveYourPassword: "စကားဝှက်မရသေးဘူးလား?",
    LabelYouCanResendItAfter: "နောက်ပိုင်းမှာ ပြန်ပို့နိုင်သည်",
    LabelYouCanResendAgain: "ပြန်ပို့နိုင်ပါသည်",
    Confirm: "အတည်ပြုပါ",
    Resend: "ပြန်ပို့ပါ",
    LabelResetPassword: "စကားဝှက်ပြန်သတ်မှတ်ပါ",
    NewPassword: "စကားဝှက်အသစ်",
    ConfirmNewPassword: "စကားဝှက်အသစ်အတည်ပြုပါ",
    PlaceHolderConfirmPassword: "စကားဝှက်ကို အတည်ပြုပါ",
    CurrentPassword: "လက်ရှိစကားဝှက်",
    LanguageSetting: "ဘာသာစကားပြင်ဆင်ခြင်း",
    LeaveMembership: "အကောင့်ဖျက်ပါ",
    LabelConfirmPasswordToLeaveMemberShip: "အကောင့်ဖျက်ရန် စကားဝှက်ကို အတည်ပြုပါ။",
    LabelConfirmPasswordMeansYouAgreeAllContent: "စကားဝှက်အတည်ပြုသည့်အခါ အကြောင်းအရာအားလုံးကို သဘောတူပါသည်ဟု ဆိုလိုသည်။",
    LabelCancelMembership: "အကောင့်ဖျက်ပါ",
    LabelBeforeLeaveYouCheckedContent: "ဖျက်မီ အောက်ပါအကြောင်းအရာကို စစ်ဆေးပြီး သဘောတူကြောင်း စစ်ဆေးပါ။",
    LabelAfterLeaveAllInfoWillRemove: "ဖျက်ပြီးပါက အကောင့်နှင့် အသုံးပြုမှတ်တမ်းများအားလုံးကို မျှော်လင့်ချက်မရှိအောင် ဖျက်လိုက်မည်။",
    LabelIHaveReadAndAgreeContent: "အကြောင်းအရာအားလုံးကို ဖတ်ပြီး သဘောတူပါသည်။",
    ToUnsubscribe: "စာရင်းမှ ပယ်ဖျက်ပါ",
    LabelWouldYouWantLogout: "အကောင့်ထွက်ချင်ပါသလား?",
    ChangePassword: "စကားဝှက်ပြောင်းပါ",
    Menu: "မီနူး",
    MenuLanguageSettings: "ဘာသာစကားပြင်ဆင်ခြင်း",
    MenuPrivacyPolicy: "ကိုယ်ရေးကိုယ်တာ မူဝါဒ",
    MenuLogout: "အကောင့်ထွက်ရန်",
    MenuLeaveMembership: "အကောင့်ဖျက်ပါ",
    LabelAreYouSureLeaveMembership: "အကောင့်ဖျက်မှာ သေချာပါသလား?",
    LabelIfLeaveMembershipAllInfoWillRemove: "အကောင့်ဖျက်ပါက အကောင့်သတင်းအချက်အလက်ကို ဖျက်မည်။ ပြန်မရနိုင်ပါ။",
    LabelPrivacyPolicy: "ကိုယ်ရေးကိုယ်တာ မူဝါဒ",
    LabelTermOfUse: "အသုံးပြုခြင်း စည်းမျဉ်းများ",
    MI_02_MSG_01: "လက်ရှိစကားဝှက်မှားနေပါသည်။",
    LabelModalLogin:`ဤလုပ်ဆောင်ချက်ကို အသုံးပြုရန်<br/>အကောင့်ဝင်ရန် သို့မဟုတ် စာရင်းသွင်းပါ။`,
    LabelIdLogin: "ID ဖြင့် လော့ဂ်အင်",
    LabelSnsApple: "Apple ဖြင့် လော့ဂ်အင်ဝင်ပါ",
    LabelSnsFacebook: "Facebook ဖြင့် လော့ဂ်အင်ဝင်ပါ",
    LabelSnsGoogle: "Google ဖြင့် လော့ဂ်အင်ဝင်ပါ",
    LabelItemLogin: "Hey! Cooker နှင့်အတူအမျိုးမျိုးသောလုပ်ဆောင်ချက်များကို စူးစမ်းလိုပါက လော့ဂ်အင် ၎င်းမှတ်ပုံတင် ပြုလုပ်ပါ။",
    LabelSnsEmail: "အီးမေးလ်ဖြင့် လော့ဂ်အင်ဝင်ပါ",
    LoadingLogin: "ကျေးဇူးပြု၍ ခဏစောင့်ပါ။",
    MenuNotificationSettings: "အသိပေးချက် ဆက်တင်", //menu
};

